import { DENTAL, LATITUDE } from 'core/constants/products'
import { APPLICATION, ADD_ONS } from 'sites/routes'
import { enableFlexBenefits } from 'utils/experiments/enableFlexBenefits'

function getNextStep(activeApplicationsResp, state: Pivot.State) {
  if (activeApplicationsResp) {
    const activeApplications = activeApplicationsResp.data || []
    const idsPlansDental = state.plansByType[DENTAL] || []
    const idsPlansLatitude = state.plansByType[LATITUDE] || []
    const idsFlexBenefits = state.externalPlans || []

    const hasDentalActive = activeApplications.some(
      app => app.productType && app.productType.toLowerCase() === 'dental' && app.active
    )

    const showDental = idsPlansDental.length > 0 && !hasDentalActive
    const showLatitude = idsPlansLatitude.length > 0
    const showFlexBenefits = idsFlexBenefits.length > 0 && enableFlexBenefits()

    if (showDental || showLatitude || showFlexBenefits) {
      return ADD_ONS
    }
  }

  return APPLICATION
}

export default getNextStep
